module.exports = __webpack_public_path__ + "static/media/Eyebrows_pink.2632f8c1.svg";